import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { servicesDetailedData } from "../../../../data/services/servicesDetailed";
import "./ServicesDetailed.css";

gsap.registerPlugin(ScrollTrigger);

const ServicesDetailed = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll(".service-detailed-card");

    cards.forEach((card) => {
      const content = card.querySelector(".service-detailed-card__content");
      const imageWrapper = card.querySelector(".service-detailed-card__image");

      gsap.fromTo(
        content,
        {
          opacity: 0,
          x: -60,
        },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      gsap.fromTo(
        imageWrapper,
        {
          opacity: 0,
          x: 60,
        },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    });
  }, []);

  return (
    <section className="services-detailed" id="detailed" ref={sectionRef}>
      <div className="services-detailed__container">
        {servicesDetailedData.map((service, index) => (
          <div
            key={service.id}
            id={service.id}
            className={`service-detailed-card ${
              index % 2 === 0
                ? "service-detailed-card--normal"
                : "service-detailed-card--reverse"
            }`}
          >
            <div className="service-detailed-card__content">
              <div className="service-detailed-card__icon-wrapper">
                <div className="service-detailed-card__icon">
                  {service.icon}
                </div>
              </div>
              <h2 className="service-detailed-card__title">{service.title}</h2>
              <p className="service-detailed-card__tagline">
                {service.tagline}
              </p>
              <p className="service-detailed-card__description">
                {service.description}
              </p>

              <div className="service-detailed-card__features">
                <h3 className="service-detailed-card__features-title">
                  What's Included:
                </h3>
                <ul className="service-detailed-card__features-list">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="service-detailed-card__results">
                <strong>Results:</strong> {service.results}
              </div>
            </div>

            <div className="service-detailed-card__image">
              <img src={service.image} alt={service.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesDetailed;
